export const currency = {
  // Currency dropdown
  currencySearch: "搜索货币...",
  currencyFiatOnly: "仅法定货币",
  currencyManage: "管理",
  currencySelectCurrency: "选择货币",
  currencyNoResults: "未找到货币",
  currencyTypeFiat: "法币",
  currencyTypeCrypto: "加密",

  // Currency management modal
  currencyManageTitle: "管理货币",
  currencyManageFiatTab: "法定货币",
  currencyManageCryptoTab: "加密货币",
  currencyManageSearchPlaceholder: "在{type}中搜索...",
  currencyManageNoFiat: "未找到法定货币",
  currencyManageNoCrypto: "未找到加密货币",
  currencyManageClose: "关闭",

  currencyName: "货币",
  cryptoNames: "加密货币",

  // Currency names
  currencyVES: "博利瓦",
  currencyUSD: "美元",
  currencyUSDT: "泰达币",
  currencyCLP: "智利比索",

  // Currency symbols
  currencySymbolVES: "Bs.",
  currencySymbolUSD: "US$",
  currencySymbolUSDT: "₮",
  currencySymbolCLP: "CL$",

  // Conversion
  currencyConversionError: "货币转换错误",
  currencyLoadingRates: "加载汇率中...",
  currencyManagementNote: "启用或禁用要在下拉菜单中显示的货币",
};
